import { render } from "./ModalBodyForCategory.vue?vue&type=template&id=6d1ca98e&scoped=true"
import script from "./ModalBodyForCategory.vue?vue&type=script&lang=js"
export * from "./ModalBodyForCategory.vue?vue&type=script&lang=js"

import "./ModalBodyForCategory.vue?vue&type=style&index=0&id=6d1ca98e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d1ca98e"]])

export default __exports__